/**
 * Client-side iso2 → Region mapping.
 * Mirrors backend/src/lib/region_for_iso2.py — kept in sync manually.
 * Used only for advisory pre-fill in CreateEntityModal; backend is authoritative.
 */
import type { Region } from "./types";

const MIDDLE_EAST = new Set(["AE","SA","QA","OM","BH","KW","IL","JO","LB","IQ","IR","YE","SY","TR"]);
const AFRICA = new Set([
  "DZ","AO","BJ","BW","BF","BI","CM","CV","CF","TD","KM","CG","CD","CI","DJ","EG","GQ","ER","ET",
  "GA","GM","GH","GN","GW","KE","LS","LR","LY","MG","MW","ML","MR","MU","MA","MZ","NA","NE","NG",
  "RW","ST","SN","SC","SL","SO","ZA","SS","SD","SZ","TZ","TG","TN","UG","ZM","ZW",
]);
const LATIN_AMERICA = new Set([
  "AR","BO","BR","CL","CO","CR","CU","DO","EC","SV","GT","HN","MX","NI","PA","PY","PE","PR","UY","VE","BZ","GY","SR","TT",
]);
const NORTH_AMERICA = new Set(["US","CA"]);
const EUROPE = new Set([
  "AL","AD","AT","BY","BE","BA","BG","HR","CY","CZ","DK","EE","FI","FR","GE","DE","GR","HU","IS","IE",
  "IT","XK","LV","LI","LT","LU","MK","MT","MD","MC","ME","NL","NO","PL","PT","RO","RU","SM","RS","SK",
  "SI","ES","SE","CH","UA","GB","VA",
]);
const ASIA_PACIFIC = new Set([
  "AF","AM","AZ","BD","BT","BN","KH","CN","FJ","GU","HK","IN","ID","JP","KZ","KP","KR","KG","LA","MO",
  "MY","MV","MN","MM","NP","NZ","PK","PG","PH","SG","LK","TW","TJ","TH","TL","TM","VN","UZ","AU","PW",
  "FM","MH","NR","WS","TO","VU","SB",
]);

export function regionForIso2(iso2: string): Region | null {
  const c = iso2.toUpperCase().trim();
  if (MIDDLE_EAST.has(c)) return "MIDDLE_EAST";
  if (AFRICA.has(c))      return "AFRICA";
  if (LATIN_AMERICA.has(c)) return "LATIN_AMERICA";
  if (NORTH_AMERICA.has(c)) return "NORTH_AMERICA";
  if (EUROPE.has(c))      return "EUROPE";
  if (ASIA_PACIFIC.has(c)) return "ASIA_PACIFIC";
  return null;
}
